import TextBox from "../../componets/TextBox";
import designData2 from "../../data/logoAndBrandingDesign2.json";

export default function Section4() {
  return (
    <div className="Section4">
      <h2 className="w-[90%] my-[24px] md:mb-0 md:w-[61%] mx-auto text-center text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] mt-[40px]">
        Our <span className="text-[#DA2128]"> Logo & Branding</span> Design
        Services
      </h2>

      <TextBox data={designData2} oddStyle="bg-[#f5f5f5] text-[#373737]" evenStyle="bg-[#f5f5f5] text-[#373737]" />
    </div>
  );
}
